module.exports = __webpack_public_path__ + "static/img/want-boy.1e6d4c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/pc/top/want-boy.png
// module id = bFuO
// module chunks = 1